/* What one family's mapping profile is in, in the words the Mapping tab, the Studio header and
   (HUB-F13) the wizard's mapping cards all use. Pure: no hook, no query. */

import { FAMILIES, familyLabel, normaliseFamilies, type Family } from "../../../domain/families";
import i18n from "../../../i18n";
import { lz } from "../../../i18n/localized";
import type { ProfileSummary } from "./types";

export const DRAFT_ONLY = "Draft only — nothing published yet.";
export const NO_PROFILE = "No profile yet.";

/** `Active version 3` | `Draft only — nothing published yet.` | `No profile yet.` */
export function profileStateLine(profile: ProfileSummary | undefined): string {
  if (!profile) return lz("mapping.noProfile", NO_PROFILE);
  if (profile.activeVersion == null) return lz("mapping.draftOnly", DRAFT_ONLY);
  return i18n.t("mapping.activeVersion", { defaultValue: "Active version {{n}}", n: profile.activeVersion });
}

/** The version the operator most likely wants to open: the draft, else the active, else the latest. */
export function openVersionOf(profile: ProfileSummary): number {
  const draft = profile.versions.find((item) => item.state === "draft");
  return draft?.version ?? profile.activeVersion ?? profile.latestVersion;
}

/** The company's enabled families in `FAMILIES` order (sales, selfbilled, rcm, import_goods); never empty. */
export function enabledFamiliesOf(enabledDocTypes: string[] | undefined): Family[] {
  const enabled = normaliseFamilies(enabledDocTypes ?? []);
  return FAMILIES.map((spec) => spec.key).filter((key) => enabled.includes(key));
}

/** The Studio's empty state, exact string per HUB-F14. */
export function noProfileCopy(family: Family): string {
  return i18n.t("mapping.noProfileForFamily", {
    defaultValue: "This company has no mapping profile for {{family}} yet.",
    family: familyLabel(family),
  });
}
